import React from "react";

const ProgressTracker = ({ value }) => {
    const clampedValue = Math.min(value, 100);
  const progressBarColor = value > 100 ? "bg-red-500" : "bg-green-500";
  const progressPinColor = value > 100 ? "text-red-500" : "text-green-600";

  return (
    <div className="w-full px-2 py-4">
      <div className="relative w-full h-12">
        {/* Horizontal progress line */}
        <div className="absolute top-1/2 left-0 right-0 h-1 bg-green-300 -translate-y-1/2 rounded-full" />
        <div
          className={`absolute top-1/2 left-0 h-1 ${progressBarColor} -translate-y-1/2 rounded-full`}
          style={{ width: `${Math.min(value, 100)}%` }}
        />

        {/* Map Pin marker */}
        <div
          className="absolute flex items-center justify-center w-10 h-10"
          style={{
            left: `${Math.min(value, 100)}%`,
            transform: "translate(-50%, -50%)",
          }}
        >
          <svg
            viewBox="0 0 24 32"
            className={`w-full h-full ${progressPinColor}`}
          >
            <path
              d="M12 0C18.6274 0 24 5.37258 24 12C24 20 12 32 12 32C12 32 0 20 0 12C0 5.37258 5.37258 0 12 0Z"
              fill="currentColor"
            />
          </svg>
          <span className="absolute text-white text-[10px] font-bold">
            {Math.round(clampedValue)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;

// import React from "react";

// const ProgressTracker = ({ value }) => {
//   return (
//     <div className="relative w-40 h-10 flex items-end">
//       {/* Base Line at bottom */}
//       <div className="absolute bottom-0 left-0 w-full h-1 bg-green-500"></div>

//       {/* Pin */}
//       <div
//         className="absolute flex flex-col items-center"
//         style={{ left: `${value}%`, transform: "translateX(-50%)" }}
//       >
//         <div className="w-6 h-6 bg-teal-800 rounded-full flex items-center justify-center text-white text-xs font-bold">
//           {value}%
//         </div>
//         {/* Stem connects pin to line */}
//         <div className="w-1 h-3 bg-green-500"></div>
//       </div>
//     </div>
//   );
// };

// export default ProgressTracker;
